import { CONTACT } from '@/mocks/contactInfo';

export default function ButtonPhone() {
  return (
    <a
      href={CONTACT.phoneHref}
      className="inline-flex items-center justify-center gap-2 whitespace-nowrap px-6 py-3 rounded-lg font-semibold text-base transition-all duration-200 border-2 border-white text-white hover:bg-white/10 cursor-pointer"
    >
      <i className="ri-phone-line text-lg w-5 h-5 flex items-center justify-center"></i>
      {CONTACT.phone}
    </a>
  );
}